import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Email verification success page
 * Shows when user successfully verifies their email
 */
const VerifySuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  
  const verified = searchParams.get('verified') === 'true';

  useEffect(() => {
    // If user is already verified and logged in, redirect to dashboard
    if (user && user.emailVerified) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  const handleContinue = () => {
    if (user && user.emailVerified) {
      navigate('/dashboard');
    } else {
      navigate('/auth');
    }
  };

  return (
    <div className="min-h-screen bg-neutral-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="card text-center">
          {verified ? (
            <>
              {/* Success Icon */}
              <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              
              <h1 className="text-2xl font-bold text-white mb-4">
                Email Verified Successfully!
              </h1>
              
              <p className="text-neutral-400 mb-6">
                Your email address has been verified. You can now access all features of your account.
              </p>
              
              <button
                onClick={handleContinue}
                className="btn primary w-full"
              >
                Continue to Dashboard
              </button>
            </>
          ) : (
            <>
              {/* Error Icon */}
              <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              
              <h1 className="text-2xl font-bold text-white mb-4">
                Verification Failed
              </h1>
              
              <p className="text-neutral-400 mb-6">
                The verification link is invalid or has expired. Please request a new verification email.
              </p>
              
              <button
                onClick={() => navigate('/auth')}
                className="btn primary w-full"
              >
                Go to Login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifySuccess;
